<script setup>
import lottie from 'lottie-web'
import { onMounted, ref } from 'vue'
import laurelLAnimation from '@/modules/core/onboarding/assets/lottie/laurel.json'

const laurelL = ref(null)
const laurelR = ref(null)

function loadAnimation (container, animationData) {
  const params = {
    container,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    animationData: { ...animationData }
  };

  lottie.loadAnimation(params)
}

onMounted(() => {
  if (laurelL.value && laurelR.value) {
    loadAnimation(laurelL.value, laurelLAnimation)
    loadAnimation(laurelR.value, laurelLAnimation)
  }
})
</script>

<template>
    <div class="flex flex-nowrap rtl:flex-row-reverse items-center gap-0 xs:gap-2 min-h-28">
        <div ref="laurelL" class="basis-1/6 shrink-0"></div>
        <slot/>
        <div ref="laurelR" class="basis-1/6 shrink-0" style="transform: scaleX(-1);"></div>
    </div>
</template>

<style scoped lang="scss">

</style>
